// extracted by mini-css-extract-plugin
export default {"visibleButton":"HideVideo_visibleButton__TkjV5","checkbox":"HideVideo_checkbox__pzjNu"};